import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconFlag = ({
  title = "Flag",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#F77769" cx="32" cy="32" r="32" />
      <path
        d="M24 38v7a1 1 0 01-2 0V23c0-.6.4-1 1-1h20.6a1 1 0 01.7 1.7l-5.6 5.6a1 1 0 000 1.4l5.6 5.6a1 1 0 01-.7 1.7H24zm0-14v12h17.2l-4-3.9a3 3 0 010-4.2l4-3.9H24z"
        fill="#FFF"
      />
    </g>
  </Svg.Icon>
)

export default IconFlag
